import React from "react"
import { motion } from "framer-motion"
import SectionTitle from "../common/SectionTitle"
import Button from "../common/Button"

export default function AboutPreview() {
  return (
    <section className="py-20 lg:py-28 bg-[#f9f6f1] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          {/* Images */}
          <motion.div
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            {/* Main Image */}
            <div className="relative rounded-[30px] overflow-hidden shadow-2xl">
              <img
                src="/images/about-spa-secondary.jpg"
                alt="Intérieur spa luxe"
                className="w-full h-[550px] object-cover"
                loading="lazy"
              />
            </div>

            {/* Floating Image */}
            <div className="hidden sm:block absolute -bottom-10 -right-10 w-56 h-72 rounded-[25px] overflow-hidden border-8 border-[#f9f6f1] shadow-2xl">
              <img
                src="/images/about-spa-main.jpg"
                alt="Soin bien-être spa"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>

            {/* Experience Badge */}
            <div className="absolute top-8 left-8 bg-white shadow-xl rounded-2xl px-6 py-5">
              <h3 className="text-3xl font-bold text-[#b8955d]">
                10+
              </h3>

              <p className="text-sm text-gray-600 mt-1">
                Des Années de Bien-être
              </p>
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <SectionTitle
              center={false}
              subtitle="A Propos Notre Spa"
              title="Une Escapade de Luxe pour se Détendre et se Ressourcer"
              description="Notre centre de spa offre un havre de paix où bien-être, beauté et détente se conjuguent pour créer des expériences inoubliables."
            />

            <div className="mt-8 space-y-6 text-gray-600 leading-relaxed">
              <p>
                Des massages revitalisants aux rituels de hammam de luxe,en passant par les soins du visage haut de gamme, chaque expérience est conçue pour rétablir l'harmonie entre le corps et l'esprit.
              </p>

              <p>
               Nos thérapeutes professionnels associent des techniques de bien-être modernes à une atmosphère apaisante pour vous offrir des soins personnalisés adaptés à vos besoins.
              </p>
            </div>

            {/* Features */}
            <div className="grid sm:grid-cols-2 gap-6 mt-10">
              <div className="bg-white rounded-2xl p-6 shadow-md">
                <h3 className="text-lg font-semibold text-[#111111] mb-3">
                  Traitements Premium
                </h3>

                <p className="text-sm text-gray-600 leading-relaxed">
                  Services de spa de luxe conçus pour une régénération complète du corps et de l'esprit.
                </p>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-md">
                <h3 className="text-lg font-semibold text-[#111111] mb-3">
                  Thérapeutes Experts
                </h3>

                <p className="text-sm text-gray-600 leading-relaxed">
                  Des spécialistes du bien-être qualifiés, dévoués à votre confort et à votre détente.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <Button
                to="/à propos"
                size="lg"
                variant="primary"
                ariaLabel="Découvrez notre spa"
              >
                En Savoir Plus
              </Button>

              <Button
                href="https://wa.me/21697902051"
                size="lg"
                variant="secondary"
                ariaLabel="Prendre rendez-vous au spa"
              >
                Réservez Maintenant
              </Button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}